import { render, staticRenderFns } from "./navPC_09m.vue?vue&type=template&id=ff1b76d0&"
import script from "./navPC_09m.vue?vue&type=script&lang=js&"
export * from "./navPC_09m.vue?vue&type=script&lang=js&"
import style0 from "./navPC_09m.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./navPC_09m.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports